const certificateData =[
    {
      "imageUrl": "https://drive.google.com/file/d/1TEUDUGdNNcM3gFrFqwyNlZIjZWPZGAC2/view?usp=drive_link",
      "title": "Data Structure",
      "image": "/Images/coding.png",
      "user_id":1
    },
    {
      "imageUrl": "https://drive.google.com/file/d/19NwdyXu5p9_SknN3Sr_-Um-GD0Dcn5f5/view?usp=drive_link",
      "title": "Python",
      "image": "/Images/codewithsagar.png",
      "user_id":2
    },
    
  ]
  export default certificateData;